import React, { useState, useEffect, useRef } from 'react'
import { config } from 'config/config.js'
import { Link } from 'react-router-dom'
import {
  cleanString,
  removeAccents,
  handleSmoothScroll,
  onClientSide,
  sendDispatchEvent
} from 'utils/utils'
import './SearchBar.scss'

export default function SearchBarView(props) {
  const [inputFocus, setInputFocus] = useState(false)
  const resultsBG = useRef()
  const searchBarInput = useRef()
  const searchBarContainer = useRef()

  useEffect(() => {
    if (onClientSide()) {
      window.addEventListener('click', handleBGClick, false)
    }
    return () => {
      if (onClientSide()) {
        window.removeEventListener('click', handleBGClick, false)
      }
    }
  }, [])

  function forceFocusChange(e, direction) {
    e.preventDefault()
    const results = document.getElementsByClassName(
      'SearchBar__results__result'
    )
    if (results) {
      if (inputFocus && results[0]) {
        direction ? results[0].focus() : results[results.length - 1].focus()
      } else {
        for (let i = 0; i < results.length; i++) {
          if (results[i] === document.activeElement) {
            const focusOn = results[i + (direction ? 1 : -1)]
            focusOn ? focusOn.focus() : searchBarInput.current.focus()
            return false
          }
        }
      }
    }
  }

  function handleKeyDown(e) {
    switch (e.keyCode) {
      case 27: // esc
        searchBarInput.current.blur()
        props.focusCallback(false)
        props.inputValueCallback('')
        resetSearch()
        break
      case 40: // down
        forceFocusChange(e, 1)
        break
      case 39: // right
        e.target.click()
        break
      case 38: // up
        forceFocusChange(e, 0)
        break
      default:
        break
    }
  }

  function handleClickResult(url) {
    sendDispatchEvent('filtroRealizado')
    resetSearch()
    if (props.enabledSearchBar) props.history.push(url)
  }

  function resetSearch(dontClearField) {
    if (!dontClearField) {
      props.inputValueCallback('')
    }
    if (props.responsive.mobileVersion && !props.noModal) {
      if (onClientSide() && props.responsive.mobileVersion) {
        handleSmoothScroll(-1)
      }
    }
    setInputFocus(false)
  }

  function renderBold(resultString) {
    let regex = new RegExp(/([\s\_\-]+)/)
    let resultArr = resultString.split(regex)
    let inputArr = props.inputValue.split(regex)
    let normResultArr = []
    let normInputArr = []
    for (let i = 0; i < resultArr.length; i++) {
      resultArr[i] &&
        normResultArr.push(removeAccents(resultArr[i]).toLowerCase())
    }
    for (let i = 0; i < inputArr.length; i++) {
      inputArr[i] && normInputArr.push(removeAccents(inputArr[i]).toLowerCase())
    }
    for (let i = 0; i < normInputArr.length; i++) {
      if (
        normInputArr[i].trim().length >= 1 &&
        cleanString(normInputArr[i], { toLowerCase: 1, removeAccents: 1 }) != ''
      ) {
        for (let ii = 0; ii < normResultArr.length; ii++) {
          let testCheck = false
          normResultArr[ii].includes(normInputArr[i]) &&
            (testCheck = normResultArr[ii].split(normInputArr[i]))
          testCheck && testCheck.splice(1, 0, normInputArr[i])
          if (testCheck) {
            let testResult = []
            let pointer = 0
            for (let iii = 0; iii < testCheck.length; iii++) {
              let spaceChar = ''

              if (
                testCheck[iii].length > 1 &&
                new RegExp(testCheck[iii] + '$').test(normResultArr[ii])
              ) {
                spaceChar = ' '
              }
              if (!Array.isArray(resultArr[ii])) {
                testResult.push(
                  resultArr[ii].substr(pointer, testCheck[iii].length) +
                    spaceChar
                )
                pointer += testCheck[iii].length
              }
            }
            testResult.length &&
              (testResult[1] = (
                <strong key={'renderBoldSearchBar' + i + '-' + ii}>
                  {testResult[1]}
                </strong>
              ))
            testResult.length && (resultArr[ii] = testResult)
          }
        }
      }
    }
    return resultArr
  }

  function contains(string, substring) {
    let regex = new RegExp(/([\s\_]+)/)
    let resultArr = substring.split(regex)
    for (let i = 0; i < resultArr.length; i++) {
      if (
        resultArr[i].trim().length &&
        cleanString(resultArr[i], { toLowerCase: 1, removeAccents: 1 }) != ''
      ) {
        if (
          !cleanString(string, { toLowerCase: 1, removeAccents: 1 }).includes(
            cleanString(resultArr[i], { toLowerCase: 1, removeAccents: 1 })
          )
        ) {
          return false
        }
      }
    }
    return true
  }

  function renderResult(make, makeImg, url, key) {
    return !props.enabledSearchBar ? (
      <Link
        key={key}
        to={url}
        className="SearchBar__results__result"
        onKeyDown={e => {
          handleKeyDown(e)
        }}
        onClick={() => {
          handleClickResult(false)
        }}
      >
        <div
          className="SearchBar__results__result__image"
          style={{ backgroundImage: 'url(' + makeImg + ')' }}
        />
        <div className="SearchBar__results__result__name">
          {renderBold(cleanString(make, { toLowerCase: 1, capitalizeAll: 1 }))}
        </div>
      </Link>
    ) : (
      <div
        key={key}
        className="SearchBar__results__result"
        onKeyDown={e => {
          handleKeyDown(e)
        }}
        onClick={() => {
          handleClickResult(url)
        }}
      >
        <div
          className="SearchBar__results__result__image"
          style={{ backgroundImage: 'url(' + makeImg + ')' }}
        />
        <div className="SearchBar__results__result__name">
          {renderBold(cleanString(make, { toLowerCase: 1, capitalizeAll: 1 }))}
        </div>
      </div>
    )
  }

  function handleMouseOver(e) {
    e.target.focus()
  }

  function handleResultClick(e) {
    if (e.target == resultsBG) {
      resetSearch(false)
    }
  }

  function renderResults() {
    return (
      <div
        className="SearchBar__results"
        ref={resultsBG}
        onClick={e => {
          handleResultClick(e)
        }}
      >
        {results()}
      </div>
    )
  }

  function renderResultGroup(title, results, key) {
    return (
      <div key={key} className={'SearchBar__results__group'}>
        <div className="SearchBar__results__group__title">{title}</div>
        {results}
      </div>
    )
  }

  function renderResultUndefined() {
    return (
      <div className={'SearchBar__results__group'}>
        <div className="SearchBar__results__result no-result">
          {props.noResultsMsg
            ? props.noResultsMsg
            : 'Não encontramos este termo, verifique a ortografia'}
        </div>
      </div>
    )
  }

  function results() {
    let { result } = props
    let renderedResults = []
    if (result && Array.isArray(result) && result.length) {
      for (let i = 0; i < result.length; i++) {
        if (
          result[i] &&
          typeof result[i] == 'object' &&
          result[i].title &&
          result[i].result &&
          Array.isArray(result[i].result) &&
          result[i].result.length
        ) {
          let groupResults = []
          for (let ii = 0; ii < result[i].result.length; ii++) {
            let { name, img, url } = result[i].result[ii]
            
            if(img && name && url){
              const cleanName = cleanString(name, {
                toLowerCase: 1,
                removeAccents: 1,
                removeSpecial: 1,
                wordOnly: 1,
              })
              const vehicleType = url.includes('motos') ? 'moto' : 'carro';
              img = `${config.urlImgS3}img/logos/${vehicleType}/${cleanName}.webp?t=${config.randomUrl}`
            }
           
            groupResults.push(
              renderResult(name, img, url, name + ii + 'Result')
            )
          }
          renderedResults.push(
            renderResultGroup(
              result[i].title,
              groupResults,
              result[i].title + i + 'Group'
            )
          )
        }
      }
    }
    if (renderedResults.length) {
      return renderedResults
    }
    return renderResultUndefined()
  }

  function handleBGClick(e) {
    if (!searchBarContainer.current.contains(e.target)) {
      props.focusCallback && props.focusCallback(false)
      props.inputValueCallback('')
    }
  }

  function handleFocus(focus) {
    if (
      focus &&
      props.fetchAutoComplete &&
      typeof props.fetchAutoComplete === 'function'
    ) {
      props.fetchAutoComplete()
    }
    setInputFocus(focus)
    props.focusCallback && props.focusCallback(focus)
  }

  function handleInputChange(value) {
    props.inputValueCallback(value)
  }

  function renderInput() {
    return (
      <div className={'SearchBar__inputcontainer'}>
        <input
          data-qa="search_bar"
          type="text"
          className={
            'SearchBar__input ' +
            (props.openResults && props.inputValue.length
              ? ' SearchBar--filled'
              : '') +
            (props.openResults ? ' SearchBar__input--open-results' : '')
          }
          ref={searchBarInput}
          placeholder={
            props.placeholder ? props.placeholder : 'Digite marca ou modelo'
          }
          onFocus={() => {
            handleFocus(true)
          }}
          onBlur={() => {
            setInputFocus(false)
          }}
          onChange={e => {
            handleInputChange(e.target.value)
          }}
          onKeyDown={e => {
            handleKeyDown(e)
          }}
          id={'searchBar'}
          autoComplete="off"
          data-hj-whitelist={true}
          value={props.inputValue}
        />
        {props.openResults &&
        props.result &&
        props.inputValue &&
        props.inputValue.length
          ? renderResults()
          : ''}
      </div>
    )
  }

  return (
    <div
      ref={searchBarContainer}
      className={
        'SearchBar' +
        (props.openResults || inputFocus ? ' SearchBar--focus' : '') +
        (props.disabled ? ' SearchBar--disabled' : '') +
        (props.className ? props.className : '')
      }
    >
      {renderInput()}
    </div>
  )
}
